/* Backbone core custom extends */
(function() {
	// Extending Backbone.Model.prototype for adding send() method
	_.extend(Backbone.Model.prototype, Backbone.Events, {
		// POST метод с передачей параметров, который передает только переданные в него данные не
		// объединяя их с данными модели
		send: function(attrs, options, isGETMethod) {
			var modelMethods = {};

			attrs || (attrs = {});
			options || (options = {});

			if (isGETMethod) {
				modelMethods.url = function() {
					return (model.url && typeof(model.url === 'function') ? model.url() : model.url) + '?' + $.param(attrs);
				};
			} else {
				modelMethods.toJSON = function() {
					return attrs;
				};
			}

			var model = this,
				fakemodel = _.extend(_.clone(model), modelMethods),
				success = options.success;

			options.success = function(resp, status, xhr) {
				delete(xhr.responseText);
				xhr.response = resp;

				// Кешируем результат запроса с помощью amplify.store.js
				if (window.amplify) {
					if (xhr.userData.options.cache) {
						// Если с бэка придет слишком много данных, то amplify упадет с ошибкой, т.к. данные не поместятся в хранилище.
						try {
							amplify.store(xhr.userData.options.key, JSON.stringify({
								xhr: xhr
							}), {
								expires: xhr.userData.options.cache
							});
						} catch (e) {}
					}
				}

				if (!model.set(model.parse(resp, xhr, attrs), options)) {
					return false;
				}

				if (success) {
					success(model, resp, xhr);
				}
			};

			options.error = wrapError(options.error, null, model, options);
			return (this.sync || Backbone.sync).call(this, isGETMethod ? 'read' : 'create', fakemodel, options);
		},

		// GET метод с передачей параметров, который передает только переданные в него данные не
		// объединяя их с данными модели
		read: function(attrs, options) {
			return this.send(attrs, options, true);
		}
	});

	// Wrap an optional error callback with a fallback error event.
	var wrapError = function (onError, message, model, options) {
		return function(resp) {
			if (onError) {
				onError(model, resp, options, message);
			}

			if (resp.statusText !== 'abort') {
				var defaultMessage = 'Произошла ошибка';

				try {
					if (resp.responseText) {
						message = JSON.parse(resp.responseText).message;
					}
				} catch (e) {}

				switch (resp.status) {
					case 401:
						defaultMessage = 'Ваша сессия истекла. Недостаточно прав для доступа к странице';
						break;
				}

				if (!options.notTriggerErrors) {
					model.trigger('error', {
						messages: message ? [message] : [defaultMessage]
					}, model, resp, options);
				}

				Common.view.hidePreloader && Common.view.hidePreloader();

				// В случае ошибок, связанных с правами доступа, переходим на главную страницу
				if (resp.status == 401) {
					setTimeout(function() {
						Common.router.index();
						location.reload();
					}, 3000);
				}
			}
		};
	};
})();
/* Backbone core custom extends */

/* Core */
var YES = true,
	NO = false,
	Core = {
		getHashUrl: function() {
			var reg = /(?:!\/)?([^\/]+)\/?(.*)/,
				hash, regData;

			try {
				hash = Backbone.history.getFragment();
			} catch (e) {
				hash = location.hash.replace(/^#/, '');
			}

			regData = reg.exec(hash) || [];

			return {
				section: regData[1],
				parameters: regData[2]
			}
		},

		Observatory: $({}),

		// Обертка над запросом которая позволяет "продавливать" переданные параметры
		// в объект xhr который приходит в метод parse модели или коллекции.
		requestWrapper: function(target, method, data, params) {
			this._req || (this._req = {});

			if (target && method && target[method] && typeof(target[method]) === 'function') {
				data || (data = {});
				params || (params = {});

				// Если у нас передан уникальный ключ запроса, параметр synchronous и уже выполняется запрос
				// с таким же uniqueness, то новый запрос игнорируется, до окончания старого
				if (params.uniqueness && params.synchronous) {
					var req = this._req[params.uniqueness];

					if (req) {
						return NO;
					}
				}

				// Если требуется то делаем предобработку данных для всех запросов
				if (this.preProcessRequestWrapperData && typeof(this.preProcessRequestWrapperData) === 'function') {
					var processedData = this.preProcessRequestWrapperData(data);

					if (processedData) {
						data = processedData;
					}
				}

				var options = params.options || {},
					arguments = [data],
					xhr = null,
					errorStatuses = {
						'error': YES,
						'timeout': YES,
						'parsererror': YES
					},
					getErrorText = this.getErrorText;

				// Если обработчик метода complete не был передан, то заменяем его на функцию-пустышку
				options.complete || (options.complete = function() {});

				// Делаем обертки для методов success и error
				if (options.complete && typeof(options.complete) === 'function') {
					options.originalCompleteHandler = options.complete;

					options.complete = function(xhr, textStatus) {
						xhr.userData || (xhr.userData = {});

						var uniqueness = xhr.userData.uniqueness,
							options = xhr.userData.options;

						if (options && options.originalCompleteHandler) {
							options.originalCompleteHandler.apply(this, arguments);
						}

						// Если статус запроса вернулся равным error, timeout или parsererror,
						// то значит произошла какая-то ошибка и нужно вывести сообщение об этом
						if (errorStatuses[textStatus] && getErrorText && typeof(getErrorText) === 'function') {
							if (this.error && typeof(this.error) === 'function') {
								this.error(getErrorText());
							}
						}

						if (options.isRecaptcha && options.headers && options.headers.RecaptchaToken) {
							Common.resetRecaptcha();
						}

						// Удаляем выполненый запрос из колекции
						if (this._req && this._req[uniqueness]) {
							delete this._req[uniqueness];
						}
					}
				}

				options.timeout || (options.timeout = 300000); // таймаут ожидания в минутах (5 мин)

				// Добавляем обработанные опции в список аргументов
				arguments.push(options);

				if (method == 'fetch') {
					arguments.shift();
				}
				target.action = params.action;

				// Выполняем запрос с параметрами
				xhr = $.extend(target[method].apply(target, arguments), {
					userData: $.extend({}, params, params.appendData && {
						sendedData: data
					})
				});

				// Если передан этот параметр то под его значением мы сохраняем запрос
				// в коллекцию и при повторном вызове запроса с таким значение сбросит
				// старый запрос сохраненный в коллекции записав на его место новый
				if (params.uniqueness) {
					this.abortRequest(params.uniqueness);
					this._req[params.uniqueness] = xhr;
				}
			}
		},

		abortRequest: function(id) {
			if (id && this._req) {
				var req = this._req[id] || {};

				if (req.abort && typeof(req.abort) === 'function') {
					req.abort();
				}
			}
		},

		navigate: function(hash, triggerRoute) {
			!this.locationBlock && this.router.navigate(hash, triggerRoute);
			return this;
		},

		toArray: function(data) {
			var returnData = [];

			if (data) {
				if (data.length) {
					returnData = data.slice(0);
				} else {
					for (var key in data) {
						returnData.push({
							name: key,
							value: data[key]
						});
					}
				}
			}
			return returnData;
		},

		toObject: function(data) {
			var returnData = {};

			if (data) {
				if (data.push && data.length) {
					$(data).each(function(i, item) {
						var itemName = item.name.split('.'),
							itemNameCount = itemName.length;

						if (itemNameCount === 1) {
							var itemData = returnData[item.name];

							if (itemData) {
								if (!itemData.push) {
									returnData[item.name] = [itemData];
								}
								returnData[item.name].push(item.value);
							} else {
								returnData[item.name] = item.value;
							}
						} else if (itemNameCount === 2) {
							var currentData = {},
							extendingReturnData = returnData[itemName[0]] || (isNaN(parseInt(itemName[1], 10)) ? {} : []);

							currentData[itemName[1]] = item.value;
							returnData[itemName[0]] = _.extend(extendingReturnData, currentData);
						} else if (itemNameCount === 3) {
							var currentData = {},
								extendingReturnData = returnData[itemName[0]] || (isNaN(parseInt(itemName[1], 10)) ? {} : []);

							currentData[itemName[1]] = _.extend(extendingReturnData[itemName[1]], {});

							currentData[itemName[1]][itemName[2]] = item.value;
							returnData[itemName[0]] = _.extend(extendingReturnData, currentData);
						}
					});
				} else {
					returnData = data;
				}
			}
			return returnData;
		},

		clone: function(obj) {
			return JSON.parse(JSON.stringify(obj));
		},

		goToPage: function(url, isForceLoad) {
			var functionalPart = url.split('#')[1] || '404',
				urlArr = functionalPart.split('/'),
				requestedUrl = functionalPart.replace(/^\/+/, ''),
				isLegitRoute = NO;

			for (var route in this.router.routes) {
				var method = this.router.routes[route];

				if (this.router.routes.hasOwnProperty(route) && route == urlArr[0]) {
					if (this.router[method]) {
						isLegitRoute = YES;
					}
				}
			}

			if (isLegitRoute) {
				// делаем задержку в одну милисекунду чтоб все обработчики были готовы слушать новое событие
				setTimeout(function() {
					this.router.navigate(requestedUrl, YES);

					if (isForceLoad && requestedUrl == Backbone.history.getFragment()) {
						this.router[urlArr.shift()](urlArr.join('/'));
					}
				}.bind(this), 1);
			}
			return this;
		},

		getCacheReset: function() {
			return $.browser.msie ? '?ajax=' + $.now() : '';
		},

		list: [],
		locationBlock: NO,

		createEventProxy: function(dataSource) {
			var proxy = {};

			_.extend(proxy, Backbone.Events);
			dataSource.bind('all', function() {
				proxy.trigger.apply(proxy, arguments);
			});
			return proxy;
		},

		set: function(name, params, render) {
			params = params || {};

			var view = params.view,
				model = params.model,
				collection = params.collection,
				dataSource = params.dataSource,
				initData = params.initData,
				data = {
					multiple: !!params.multiple,
					standalone: params.standalone && params.standalone.push ? params.standalone : !!params.standalone
				},
				exeptionList = {
					'view': YES,
					'_view': YES,
					'standalone': YES,
					'multiple': YES,
					'eventProxy': YES
				},
				undefined;

			if (dataSource) {
				var object = this.get(dataSource);

				for (var key in object) {
					if (!exeptionList[key]) {
						data[key] = object[key];
					}
				}
			} else {
				if (collection) {
					data.collection = new collection(initData);
				} else {
					if (model) {
						data.model = new model(initData);
					} else if (model == undefined && this.Models[name]) {
						data.model = new this.Models[name](initData);
					}
				}
			}

			if (data.model || data.collection) {
				data.eventProxy = this.createEventProxy(data.model || data.collection);
			}

			if (view) {
				data._view = view;
			} else if (view == undefined && this.Views[name]) {
				data._view = this.Views[name];
			}

			// Проставляем во вью имя бандла к которому она относится.
			// Необходимо для работы метода .unload() внутри вью.
			if (data._view != null) {
				data._view.prototype.__super = this;
				data._view.prototype.__bundleName = name;
			}

			this['__' + name] = data;
			this.list.push(name);

			if (render) {
				setTimeout(function() {
					this.render(name);
				}.bind(this), 1);
			}
			return this;
		},

		render: function(name, params) {
			params = params || {};

			var data = this.get(name),
				viewData = $.extend(params, data);

			data.render = this.render.bind(this);

			if (data && data._view && !data.view) {
				if (data.multiple) {
					var tmpName = name + Math.floor(Math.random() * 10000),
						dummyBundle = $.extend({}, data);

					dummyBundle.view = new dummyBundle._view(viewData);
					this['__' + tmpName] = dummyBundle;
					this.list.push(tmpName);
				} else {
					this['__' + name].view = new data._view(viewData);
				}
			}
			return data;
		},

		renderStream: function(bandlesList, params) {
			params || (params = {});

			$.each(bandlesList, function(i, bandle) {
				var name = '';

				if (bandle && typeof(bandle) === 'string') {
					name = bandle;
				} else if ('name' in bandle) {
					name = bandle.name;
				}
				this.render(name, $.extend({}, params, bandle.params));
			}.bind(this));
			return this;
		},

		get: function(name) {
			return this['__' + name] || {
				multiple: NO,
				standalone: NO,
				_view: Backbone.View
			};
		},

		unload: function(viewName) {
			var list = viewName ? [viewName] : this.list,
				currentHashUrl = window.location.hash.replace('/', '');

			this.locationBlock = YES;
			$.each(list, function(i, name) {
				var object = this.get(name),
					isStandalone = !!object.standalone,
					view = object.view;

				if (isStandalone && object.standalone.push) {
					isStandalone = NO;
					$.each(object.standalone, function(j, route) {
						if (currentHashUrl.indexOf(route.replace('/', '')) >= 0) {
							isStandalone = YES;
							return;
						}
					});
				}

				if (view && (!isStandalone || !!viewName)) {
					view.remove();
					delete this['__' + name].view;
				}

				if (object.eventProxy) {
					object.eventProxy.unbind();
				}
			}.bind(this));
			this.locationBlock = NO;
			return this;
		},

		restore: function() {
			// Пробуем найти контейнер к которому приложение было изначально привязано
			var selector = this.container.selector,
				container = $(selector);

			// Если получается найти его то вставляем в него старый каркас
			if (container.length) {
				container
					.empty()
					.append(this.view.el);

				// Указываем ссылку на новый контейнер
				this.container = container;

				// Пробегаемся по всем активным вью и делаем ребинд событий
				$.each(this.list, function(i, name) {
					var view = this['__' + name].view;

					if (view) {
						view.delegateEvents(view.events);
					}
				}.bind(this));

				// Сбрасываем роутинг на дефолтовую страницу тем самым возобновляя навигацию
				window.location.hash = Math.random();
			}
		},

		// Метод для создания коллекции с idAttribute = Id
		createCollection: function(items, model, id) {
			model = model || Backbone.Model;

			var collection = new (Backbone.Collection.extend({
					model: model.extend({
						idAttribute: id || 'Id'
					})
				}));

			collection.reset(items);

			return collection;
		},

		modifyAutocomplete: function () {
			function makeUrlParam(name, value) {
				return [name, encodeURIComponent(value)].join('=');
			}

			function makeUrl(url, params) {
				var urlAppend = [];
				$.each(params, function(index, value) {
					urlAppend.push(makeUrlParam(index, value));
				});
				if (urlAppend.length) {
					url += url.indexOf('?') === -1 ? '?' : '&';
					url += urlAppend.join('&');
				}
				return url;
			}

			$.Autocompleter.prototype.makeUrl = function(param) {
				var self = this;
				var url = this.options.url;
				var params = $.extend({}, this.options.extraParams);

				for (var key in params) {
					if (params.hasOwnProperty(key) && _.isFunction(params[key])) {
						params[key] = params[key]();
					}
				}

				if (this.options.queryParamName === false) {
					url += encodeURIComponent(param);
				} else {
					params[this.options.queryParamName] = param;
				}
			
				return makeUrl(url, params);
			};
		}
	};
/* Core */

/* Native js custom extends */
// Расширяем объект массива
$A = Array.from = function(iterable) {
	if (!iterable) {
		return [];
	}
	if (iterable.toArray) {
		return iterable.toArray();
	} else {
		var results = [];
		for (var i = 0, length = iterable.length; i < length; i++) {
			results.push(iterable[i]);
		}
		return results;
	}
};


// Расширяем прототип функции для добавления передачи контекста через .bind()
$.extend(Function.prototype, {
	bind: function() {
		var __method = this,
			args = $A(arguments),
			object = args.shift();

		return function() {
			return __method.apply(object, args.concat($A(arguments)));
		};
	}
});


// Расширяем метод .val() на текстовые поля с placeholder
var originalValMethod = $.fn.val;

$.fn.val = function(value) {
	var currentValue = originalValMethod.apply(this, arguments);

	// Подменяем значение поля с placeholder
	if (this.is('[placeholder]') && (typeof value === 'undefined') && ((this.attr('placeholder') + ' ') === currentValue)) {
		return '';
	}
	return currentValue;
};

$.fn.continue = function () {
	return this;
};

$.fn.caret = $.fn.caret || function (begin, end) {
	var range;

	if (this.length === 0 || this.is(":hidden")) {
		return;
	}

	if (typeof begin == 'number') {
		end = (typeof end === 'number') ? end : begin;
		return this.each(function() {
			if (this.setSelectionRange) {
				this.setSelectionRange(begin, end);
			} else if (this.createTextRange) {
				range = this.createTextRange();
				range.collapse(true);
				range.moveEnd('character', end);
				range.moveStart('character', begin);
				range.select();
			}
		});
	} else {
		if (this[0].setSelectionRange) {
			begin = this[0].selectionStart;
			end = this[0].selectionEnd;
		} else if (document.selection && document.selection.createRange) {
			range = document.selection.createRange();
			begin = 0 - range.duplicate().moveStart('character', -100000);
			end = begin + range.text.length;
		}
		return { begin: begin, end: end };
	}
};

function getElementPositionEx(elem, context){
	if(elem===null) return {left:0,top:0,width:0,height:0};
	var w = elem.offsetWidth;
	var h = elem.offsetHeight;

	var l = 0;
	var t = 0;
	var e = elem;

	while (e && e !== context){
		l += e.offsetLeft;
		t += e.offsetTop;
		e = e.offsetParent;
	}
	for(e = elem.parentNode; e && e != document.body; e = e.parentNode){
		if(e.scrollTop)
			t -= e.scrollTop;
	}
	return {"left":l, "top":t, "width": w, "height":h};
}

// Get random guid
function getGuid () {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
		return v.toString(16);
	});
}

// Заглушка для объекта console в старых браузерах
if (typeof window.console == 'undefined') {
	window.console = {};
	console.log = console.info = console.warn = console.debug = console.group = console.groupEnd = console.error = console.time = console.timeEnd = function() {};
}
/* Native js custom extends */
